export default function NavItemDirective() {
  return {
    scope: {
      active: '=',
      disabled: '=',
      url: '=',
      click: '&?'
    },
    restrict: 'E',
    transclude: true,
    controller: ($scope, $element) => {
      'ngInject';

      $element.addClass('navItem');

      $scope.$watch('active', function () {
        if ($scope.active) {
          $element.addClass('active');
        } else {
          $element.removeClass('active');
        }
      });
    },
    template: `
      <a ng-class="{ disabled: disabled }" ng-href="{{ disabled ? null : url }}" ng-if="!click" ng-transclude></a>
      <a ng-class="{ disabled: disabled }" ng-click="click()" ng-if="click" ng-transclude></a>`
  };
}
